import {useEffect,useMemo,useState,} from  
"react";

import {
  useNavigate,
} from "react-router-dom";

import {
  getLeaves,
  getAllLeaves,
  getLeaveBalance,
  getLeaveTypes,
} from "../api/api";

// =====================================================
// RESPONSIVE HOOK
// =====================================================

function useIsMobile() {

  const [isMobile, setIsMobile] =
    useState(window.innerWidth < 768);




  useEffect(() => {

    const handler = () =>
      setIsMobile(window.innerWidth < 768);

    window.addEventListener(
      "resize",
      handler
    );

    return () =>
      window.removeEventListener(
        "resize",
        handler
      );

  }, []);

  return isMobile;
}
const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};
// =====================================================
// MAIN COMPONENT
// =====================================================

export default function Home() {

  const navigate =
    useNavigate();

  const isMobile =
    useIsMobile();

  const [leaves, setLeaves] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(null);

  const [currentPage, setCurrentPage] =
    useState(1);

  const [leaveBalance, setLeaveBalance] =
    useState(null);

  const [leaveTypes, setLeaveTypes] =
    useState([]);

  const leavesPerPage = 10;

  const [filters, setFilters] =
    useState({
      search: "",
      type: "All",
    });

  const [user, setUser] =
    useState({
      name: "",
      email: "",
      role: "",
    });

  const [selectedCard, setSelectedCard] =
    useState(null);

  const today =
    new Date();

  const firstDay =
    new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );

  const lastDay =
    new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );

  const [dateRange, setDateRange] =
    useState({

      from:
        firstDay
          .toISOString()
          .split("T")[0],

      to:
        lastDay
          .toISOString()
          .split("T")[0],
    });

  // =====================================================
  // USER
  // =====================================================

  useEffect(() => {

    const storedUser =
      JSON.parse(
        localStorage.getItem("user")
      ) || {};

    setUser({

      name:
        storedUser.name || "",

      email:
        storedUser.email || "",

      role:
        storedUser.role || "employee",
    });

  }, []);

  // =====================================================
  // RESET PAGE
  // =====================================================

  useEffect(() => {

    setCurrentPage(1);

  }, [filters]);

  const isManager =
    user.role === "manager";

  // =====================================================
  // INITIAL LOAD
  // =====================================================

  useEffect(() => {

    if (user.role) {

      fetchLeaves();

      fetchLeaveBalance();

      fetchLeaveTypes();
    }

  }, [user.role]);

  // =====================================================
  // HOLIDAYS
  // =====================================================

  const holidayData = {

    January: [

      {
        date: "2026-01-01",
        name: "New Year's Day",
      },

      {
        date: "2026-01-26",
        name: "Republic Day",
      },
    ],

    August: [

      {
        date: "2026-08-15",
        name: "Independence Day",
      },
    ],

    October: [

      {
        date: "2026-10-02",
        name: "Gandhi Jayanti",
      },
    ],

    December: [

      {
        date: "2026-12-25",
        name: "Christmas",
      },
    ],
  };

  const holidays =
    useMemo(() => {

      const today =
        new Date();

      return Object
        .values(holidayData)
        .flat()
        .filter(
          (h) =>
            new Date(h.date) >= today
        )
        .sort(
          (a, b) =>
            new Date(a.date) -
            new Date(b.date)
        );

    }, []);

  // =====================================================
  // FETCH LEAVES
  // =====================================================

  const fetchLeaves = async () => {

    try {

      setLoading(true);

      setError(null);

      let res;

      if (isManager) {

        const allLeaves =
          await getAllLeaves();

        const currentUser =
          JSON.parse(
            localStorage.getItem("user")
          );

        res =
          allLeaves.filter(
            (l) =>
              l.user_id !==
              currentUser.id
          );

      } else {

        res =
          await getLeaves();
      }

      setLeaves(
        Array.isArray(res)
          ? res
          : []
      );

    } catch (err) {

      console.error(err);

      setError(
        "Failed to load leaves"
      );

    } finally {

      setLoading(false);
    }
  };

  // =====================================================
  // FETCH BALANCE
  // =====================================================

  const fetchLeaveBalance =
    async () => {

      try {

        const data =
          await getLeaveBalance();

        setLeaveBalance(data);

      } catch (error) {

        console.error(error);
      }
    };



  // =====================================================
  // FETCH LEAVE TYPES
  // =====================================================

  const fetchLeaveTypes =
    async () => {

      try {

        const data =
          await getLeaveTypes();

        setLeaveTypes(data || []);

      } catch (error) {

        console.error(error);
      }
    };


        useEffect(() => {

  const refreshLeaves = () => {

    fetchLeaves();

    fetchLeaveBalance();
  };

  window.addEventListener(
    "leave-updated",
    refreshLeaves
  );

  return () => {

    window.removeEventListener(
      "leave-updated",
      refreshLeaves
    );
  };

}, []);

  // =====================================================
  // FILTERED LEAVES
  // =====================================================

  const filteredLeaves =
    useMemo(() => {

      return leaves.filter((l) => {

        const leaveTypeName =
          (
            l.leave_type_name ||
            l.leave_type ||
            ""
          )
            .trim()
            .toLowerCase();

        const matchesType =

          filters.type === "All" ||

          leaveTypeName ===
          filters.type.toLowerCase();

        const matchesSearch =

          !filters.search ||

          `${leaveTypeName} ${l.reason || ""}`
            .toLowerCase()
            .includes(
              filters.search.toLowerCase()
            );

        return (
          matchesType &&
          matchesSearch
        );
      });

    }, [leaves, filters]);

  // =====================================================
  // SORTED LEAVES
  // =====================================================

  const sortedLeaves =
    useMemo(() =>

      [...filteredLeaves].sort(
        (a, b) =>

          new Date(b.created_at) -
          new Date(a.created_at)
      ),

    [filteredLeaves]);

  // =====================================================
  // PAGINATION
  // =====================================================

  const totalPages =
    Math.ceil(
      sortedLeaves.length /
      leavesPerPage
    );

  const paginatedLeaves =
    useMemo(() => {

      const start =
        (currentPage - 1) *
        leavesPerPage;

      return sortedLeaves.slice(
        start,
        start + leavesPerPage
      );

    }, [
      sortedLeaves,
      currentPage,
    ]);

  // =====================================================
  // KPI SUMMARY
  // =====================================================

const summary =
  useMemo(() => {

    const from =
      new Date(dateRange.from);

    const to =
      new Date(dateRange.to);

    const filtered =
      leaves.filter((l) => {

        const leaveDate =
          new Date(l.from_date);

        return (
          leaveDate >= from &&
          leaveDate <= to
        );
      });

    const count = (category) =>

      filtered
        .filter(
          (l) =>

            (
              l.leave_category ||
              ""
            )
              .toLowerCase()
              .includes(
                category.toLowerCase()
              ) &&

            (
              !l.status ||

              [
                "pending",
                "approved",
              ].includes(
                l.status.toLowerCase()
              )
            )
        )
        .reduce(
          (sum, l) =>
            sum +
            (
              Number(l.days) || 0
            ),
          0
        );

    // ===========================================
    // MONTHLY LOP
    // ===========================================

// ===========================================
// LOP FOR CURRENT PAYROLL CYCLE (26 -> 25)
// ===========================================

const today = new Date();

let cycleStart;
let cycleEnd;

if (today.getDate() >= 26) {
  cycleStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    26
  );

  cycleEnd = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    25
  );
} else {
  cycleStart = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    26
  );

  cycleEnd = new Date(
    today.getFullYear(),
    today.getMonth(),
    25
  );
}

const lop = leaves
  .filter((l) => {
    if (l.status?.toLowerCase() !== "approved") {
      return false;
    }

    const fromDate = new Date(l.from_date);
    const toDate = new Date(l.to_date);

    // Leave must start within the current payroll cycle
    return (
      fromDate >= cycleStart &&
      fromDate <= cycleEnd
    );
  })
  .reduce(
    (sum, l) =>
      sum + Number(l.lop_days || 0),
    0
  );
    return {

      planned:
        count("planned"),

      unplanned:
        count("unplanned"),

      sick:
        count("sick"),

      lop:
        lop,
    };

  }, [
    leaves,
    dateRange,
  ]);

  // =====================================================
  // STATUS BADGE
  // =====================================================

  const getStatusBadge =
    (status) => {

      switch (status) {

        case "approved":

          return {
            background: "#2e7d32",
            color: "#fff",
          };

        case "rejected":

          return {
            background: "#d32f2f",
            color: "#fff",
          };

        case "pending":

          return {
            background: "#ed6c02",
            color: "#fff",
          };

        case "withdrawn":

          return {
            background: "#6d4c41",
            color: "#fff",
          };

        default:

          return {
            background: "#616161",
            color: "#fff",
          };
      }
    };

const handleNavigate = (path) => {

  // Prevent duplicate history entries
  if (window.location.pathname === path) {
    return;
  }

  // Proper route push for mobile webview
  navigate(path, {
    replace: false,
    state: {
      fromDashboard: true,
    },
  });

  // Extra history support for Android/iOS webview
  window.history.pushState(
    { path },
    "",
    path
  );
};

  const s =
    getStyles(isMobile);

  return (

    <div style={s.page}>

      {/* ===================================================== */}
      {/* HEADER */}
      {/* ===================================================== */}

      <div style={s.headerRow}>

        <div>

          <div style={s.pageTitle}>
            Dashboard
          </div>

          <div style={s.subTitle}>
            Overview & quick actions
          </div>

        </div>

        <div style={s.headerActions}>

          {!isManager && (

            <button
              style={s.primaryBtn}

              onClick={() =>
                handleNavigate(
                  "/leave/apply"
                )
              }
            >
              Apply Leave
            </button>
          )}

        </div>

      </div>

      {/* ===================================================== */}
      {/* PROFILE */}
      {/* ===================================================== */}

      <div style={s.grid2}>

        <div style={s.card}>

          <div
            style={{
              ...s.profileRow,
              cursor: "pointer",
            }}

            onClick={() =>
              handleNavigate("/profile")
            }
          >

            <div style={s.avatar}>

              {user.name

                ? user.name
                    .charAt(0)
                    .toUpperCase()

                : user.email
                    ?.charAt(0)
                    .toUpperCase()}

            </div>

            <div>

              <div style={s.name}>

                Welcome,
                {" "}
                {user.name?.split(" ")[0]}

              </div>

              <div style={s.meta}>
                {user.email}
              </div>

            </div>

          </div>

        </div>

        {/* ===================================================== */}
        {/* KPI */}
        {/* ===================================================== */}

        <div style={s.kpiRow}>

          <KpiCard
            label="Planned Leave"
            value={
              leaveBalance
                ?.planned_balance || 0
            }
            isMobile={isMobile}
            
          />

          <KpiCard
            label="Unplanned Leave"
            value={
              leaveBalance
                ?.unplanned_balance || 0
            }
            isMobile={isMobile}
            
          />

          <KpiCard
  label="Loss Of Pay"
  value={summary.lop}
            isMobile={isMobile}
           
          />

        </div>

        {/* ===================================================== */}
        {/* EXPAND CARD */}
        {/* ===================================================== */}

        {selectedCard && (

          <div style={s.expandCard}>

            <div style={s.expandHeader}>

              <div style={s.cardTitle}>
                {selectedCard} Details
              </div>

            </div>

            <div style={s.dateRow}>

              <div>

                <label>
                  From
                </label>

                <input
                  type="date"

                  value={dateRange.from}

                  onChange={(e) =>
                    setDateRange({

                      ...dateRange,

                      from:
                        e.target.value,
                    })
                  }
                />

              </div>

              <div>

                <label>
                  To
                </label>

                <input
                  type="date"

                  value={dateRange.to}

                  onChange={(e) =>
                    setDateRange({

                      ...dateRange,

                      to:
                        e.target.value,
                    })
                  }
                />

              </div>

            </div>

            <div style={s.expandCount}>

              Count:
              {" "}

              {selectedCard === "Planned Leave"

                ? summary.planned

                : selectedCard === "Unplanned Leave"

                ? summary.unplanned

                : summary.lop}

            </div>

          </div>
        )}

      </div>

      {/* ===================================================== */}
      {/* QUICK ACTIONS */}
      {/* ===================================================== */}

      {!isManager && (

        <div style={s.card}>

          <div style={s.cardTitle}>
            Quick Actions
          </div>

          <div style={s.actionsRow}>

            {[
              {
                title:
                  "Apply Leave",

                path:
                  "/leave/apply",
              },

              {
                title:
                  "Leave Balance",

                path:
                  "/leave/balance",
              },

              {
                title:
                  "Leave Calendar",

                path:
                  "/leave/calendar",
              },

              {
                title:
                  "Pending Leaves",

                path:
                  "/leave/pending-tab",
              },

              {
                title:
                  "Leave History",

                path:
                  "/leave/history-tab",
              },

            ].map((item) => (

              <ActionCard

                key={item.title}

                title={item.title}

                isMobile={isMobile}

                onClick={() =>
                  handleNavigate(
                    item.path
                  )
                }
              />
            ))}

          </div>

        </div>
      )}

      {/* ===================================================== */}
      {/* RECENT LEAVES */}
      {/* ===================================================== */}

      <div style={s.gridMain}>

        <div
          style={{
            ...s.card,
            ...s.leftSection,
          }}
        >

          {/* HEADER */}

          <div style={s.cardHeaderRow}>

            <div style={s.cardTitle}>
              Recent Leave Applications
            </div>

            <div style={s.filters}>

              <input
                style={s.input}

                placeholder="Search"

                value={filters.search}

                onChange={(e) =>
                  setFilters({

                    ...filters,

                    search:
                      e.target.value,
                  })
                }
              />

              <select
                style={s.input}

                value={filters.type}

                onChange={(e) =>
                  setFilters({

                    ...filters,

                    type:
                      e.target.value,
                  })
                }
              >

                <option>
                  All
                </option>

                {leaveTypes.map((type) => (

                  <option
                    key={type.id}
                  >
                    {type.name}
                  </option>
                ))}

              </select>

            </div>

          </div>

          {/* CONTENT */}

          {loading ? (

            <div style={s.center}>
              Loading…
            </div>

          ) : error ? (

            <div style={s.error}>
              {error}
            </div>

          ) : paginatedLeaves.length === 0 ? (

            <div style={s.center}>
              No leaves found
            </div>

          ) : isMobile ? (

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginTop: "12px",
              }}
            >

              {paginatedLeaves.map((l) => (

                <LeaveCard
                  key={l.id}
                  leave={l}
                  getStatusBadge={
                    getStatusBadge
                  }
                />
              ))}

            </div>

          ) : (

            <div
              style={{
                width: "100%",
                overflowX: "auto",
              }}
            >

              <table
                style={{
                  ...s.table,
                  marginTop: "20px",
                  minWidth: "700px",
                }}
              >

                <thead style={s.tableHead}>

                  <tr>

                    <th style={s.th}>
                      Type
                    </th>

                    <th style={s.th}>
                      From
                    </th>

                    <th style={s.th}>
                      To
                    </th>

                    <th style={s.th}>
                      Days
                    </th>

                    <th style={s.th}>
                      Status
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {paginatedLeaves.map((l) => (

                    <tr
                      key={l.id}
                      style={s.tableRow}
                    >

                      <td style={s.td}>
                        {l.leave_type_name}
                      </td>

                      <td style={s.td}>
                        {formatDate(l.from_date)}
                      </td>

                      <td style={s.td}>
                        {formatDate(l.to_date)}
                      </td>

                      <td style={s.td}>
                        {l.days}
                      </td>

                      <td style={s.td}>

                        <span
                          style={{
                            ...s.statusBadge,

                            ...getStatusBadge(
                              l.status
                            ),
                          }}
                        >

                          {l.status
                            ?.charAt(0)
                            .toUpperCase() +
                            l.status?.slice(1)}

                        </span>

                      </td>

                    </tr>
                  ))}

                </tbody>

              </table>

            </div>
          )}

          {/* ===================================================== */}
          {/* PAGINATION */}
          {/* ===================================================== */}

          <div
            style={{
              marginTop: "28px",

              display: "flex",

              justifyContent:
                "center",

              alignItems: "center",

              gap: "14px",
            }}
          >

            <button
              onClick={() =>
                setCurrentPage((p) =>
                  Math.max(p - 1, 1)
                )
              }

              disabled={
                currentPage === 1
              }

              style={s.pageBtn}
            >
              ◀
            </button>

            <div style={s.pageIndicator}>

              {currentPage}
              {" / "}
              {totalPages || 1}

            </div>

            <button
              onClick={() =>
                setCurrentPage((p) =>
                  Math.min(
                    p + 1,
                    totalPages
                  )
                )
              }

              disabled={
                currentPage === totalPages ||
                totalPages === 0
              }

              style={s.pageBtn}
            >
              ▶
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

// =====================================================
// LEAVE CARD
// =====================================================

function LeaveCard({

  leave: l,

  getStatusBadge,
}) {

  return (

    <div
      style={{
        background: "#fff",

        border:
          "1px solid #e2e8f0",

        borderRadius: "16px",

        padding: "16px",

        boxShadow:
          "0 4px 14px rgba(15,23,42,0.05)",
      }}
    >

      <div
        style={{
          display: "flex",

          justifyContent:
            "space-between",

          alignItems: "center",

          marginBottom: "10px",
        }}
      >

        <span
          style={{
            fontWeight: "700",

            fontSize: "14px",

            color: "#111827",
          }}
        >

          {l.leave_type_name}

        </span>

        <span
          style={{
            padding: "5px 12px",

            borderRadius: "999px",

            fontSize: "11px",

            fontWeight: "700",

            textTransform:
              "capitalize",

            letterSpacing: "0.4px",

            ...getStatusBadge(
              l.status
            ),
          }}
        >

          {l.status
            ?.charAt(0)
            .toUpperCase() +
            l.status?.slice(1)}

        </span>

      </div>

      <div
        style={{
          display: "flex",

          gap: "18px",

          marginBottom: "8px",
        }}
      >

        <div>

          <div style={smallLabel}>
            From
          </div>

          <div style={smallValue}>
  {formatDate(l.from_date)}
</div>

        </div>

        <div
          style={{
            borderLeft:
              "1px solid #e2e8f0",
          }}
        />

        <div>

          <div style={smallLabel}>
            To
          </div>

          <div style={smallValue}>
           {formatDate(l.to_date)}
          </div>

        </div>

      </div>

      {l.reason && (

        <div
          style={{
            fontSize: "12px",

            color: "#6b7280",

            borderTop:
              "1px solid #f1f5f9",

            paddingTop: "8px",

            marginTop: "4px",
          }}
        >

          {l.reason}

        </div>
      )}

    </div>
  );
}

// =====================================================
// KPI CARD
// =====================================================

function KpiCard({

  label,

  value,

  onClick,

  isMobile,
}) {

  return (

    <div
      onClick={onClick}

      style={{
        cursor: "pointer",

        background:
          "linear-gradient(135deg,#ffffff,#f8fbff)",

        borderRadius:
          isMobile
            ? "16px"
            : "22px",

        padding:
          isMobile
            ? "14px 10px"
            : "22px",

        border:
          "1px solid #e2e8f0",

        boxShadow:
          "0 8px 24px rgba(15,23,42,0.05)",
      }}
    >

      <div
        style={{
          fontSize: "11px",

          color: "#64748b",

          fontWeight: "700",

          textTransform:
            "uppercase",

          letterSpacing: "0.5px",

          marginBottom: "8px",
        }}
      >

        {label}

      </div>

      <div
        style={{
          fontSize:
            isMobile
              ? "22px"
              : "36px",

          fontWeight: "800",

          color: "#0f172a",
        }}
      >

        {value}

      </div>

    </div>
  );
}

// =====================================================
// ACTION CARD
// =====================================================

function ActionCard({

  title,

  onClick,

  isMobile,
}) {

  return (

    <div
      onClick={onClick}

      style={{
        padding:
          isMobile
            ? "14px"
            : "20px",

        borderRadius: "16px",

        background:
          "linear-gradient(135deg,#eff6ff,#ffffff)",

        border:
          "1px solid #dbeafe",

        cursor: "pointer",

        textAlign: "center",

        fontWeight: "700",

        fontSize:
          isMobile
            ? "13px"
            : "15px",

        color: "#1e3a8a",

        boxShadow:
          "0 6px 18px rgba(37,99,235,0.08)",
      }}
    >

      {title}

    </div>
  );
}

const smallLabel = {

  fontSize: "10px",

  color: "#94a3b8",

  fontWeight: "600",

  textTransform: "uppercase",

  letterSpacing: "0.5px",
};

const smallValue = {

  fontSize: "13px",

  color: "#374151",

  fontWeight: "600",

  marginTop: "2px",
};

// =====================================================
// STYLES
// =====================================================

function getStyles(isMobile) {

  return {

    page: {

      padding:
        isMobile
          ? "14px"
          : "24px",

      background: "#f4f7fb",

      minHeight: "100vh",

      fontFamily:
        "'Inter', sans-serif",
    },

    headerRow: {

      display: "flex",

      justifyContent:
        "space-between",

      alignItems: "center",

      marginBottom: "20px",

      gap: "12px",

      flexWrap: "nowrap",
    },

    pageTitle: {

      fontSize:
        isMobile
          ? "24px"
          : "34px",

      fontWeight: "800",

      color: "#111827",

      letterSpacing: "-1px",
    },

    subTitle: {

      fontSize: "14px",

      color: "#6b7280",

      marginTop: "6px",
    },

    headerActions: {

      display: "flex",

      gap: "12px",
    },

    primaryBtn: {

      background:
        "linear-gradient(135deg,#2563eb,#1d4ed8)",

      color: "#fff",

      padding:
        isMobile
          ? "10px 14px"
          : "14px 24px",

      border: "none",

      borderRadius: "14px",

      fontWeight: "700",

      fontSize:
        isMobile
          ? "12px"
          : "14px",

      cursor: "pointer",

      whiteSpace: "nowrap",
    },

    grid2: {

      display: "flex",

      flexDirection: "column",

      gap: "22px",

      marginBottom: "24px",
    },

    card: {

      background: "#ffffff",

      borderRadius:
        isMobile
          ? "18px"
          : "26px",

      padding:
        isMobile
          ? "16px"
          : "24px",

      boxShadow:
        "0 10px 40px rgba(15,23,42,0.06)",

      border:
        "1px solid #edf2f7",

      marginBottom:
        isMobile
          ? "14px"
          : "0",
    },

    profileRow: {

      display: "flex",

      alignItems: "center",

      gap: "18px",
    },

    avatar: {

      width:
        isMobile
          ? "54px"
          : "72px",

      height:
        isMobile
          ? "54px"
          : "72px",

      borderRadius: "50%",
      background:
        "linear-gradient(135deg,#2563eb,#7c3aed)",

      color: "#fff",

      display: "flex",

      alignItems: "center",

      justifyContent: "center",

      fontSize:
        isMobile
          ? "20px"
          : "28px",

      fontWeight: "700",

      flexShrink: 0,
    },

    name: {

      fontSize:
        isMobile
          ? "16px"
          : "22px",

      fontWeight: "700",

      color: "#111827",
    },

    meta: {

      fontSize: "14px",

      color: "#6b7280",

      marginTop: "6px",
    },

    kpiRow: {

      display: "grid",

      gridTemplateColumns:

        isMobile

          ? "repeat(3,1fr)"

          : "repeat(auto-fit,minmax(180px,1fr))",

      gap:
        isMobile
          ? "8px"
          : "18px",
    },

    expandCard: {

      width: "100%",

      background: "#fff",

      padding: "24px",

      borderRadius: "24px",

      border:
        "1px solid #e2e8f0",
    },

    expandHeader: {

      marginBottom: "20px",
    },

    dateRow: {

      display: "flex",

      gap: "20px",

      flexWrap: "wrap",
    },

    expandCount: {

      marginTop: "20px",

      fontSize: "28px",

      fontWeight: "800",

      color: "#111827",
    },

    cardTitle: {

      fontSize:
        isMobile
          ? "16px"
          : "20px",

      fontWeight: "700",

      color: "#111827",
    },

    actionsRow: {

      display: "grid",

      gridTemplateColumns:

        isMobile

          ? "repeat(2,1fr)"

          : "repeat(auto-fit,minmax(180px,1fr))",

      gap: "12px",

      marginTop: "16px",
    },

    gridMain: {

      display: "flex",

      flexDirection:
        isMobile
          ? "column"
          : "row",

      gap: "18px",
    },

    leftSection: {

      flex: 3,
    },

    cardHeaderRow: {

      display: "flex",

      justifyContent:
        "space-between",

      alignItems:

        isMobile
          ? "flex-start"
          : "center",

      marginBottom: "12px",

      flexWrap: "wrap",

      gap: "12px",
    },

    filters: {

      display: "flex",

      gap: "10px",

      flexWrap: "wrap",

      width:
        isMobile
          ? "100%"
          : "auto",
    },

    input: {

      padding: "10px 12px",

      border:
        "1px solid #d1d5db",

      borderRadius: "12px",

      outline: "none",

      fontSize: "13px",

      background: "#fff",

      width:
        isMobile
          ? "100%"
          : "180px",
    },

    table: {

      width: "100%",

      borderCollapse:
        "separate",

      borderSpacing:
        "0 12px",

      textAlign: "left",

      fontSize: "14px",
    },

    tableHead: {

      background: "transparent",
    },

    tableRow: {

      background: "#fff",

      borderRadius: "16px",
    },

    th: {

      padding: "14px",

      fontWeight: "700",

      fontSize: "13px",

      color: "#64748b",

      textTransform:
        "uppercase",

      letterSpacing: "0.5px",
    },

    td: {

      padding: "18px 14px",

      color: "#111827",

      borderTop:
        "1px solid #f1f5f9",

      borderBottom:
        "1px solid #f1f5f9",

      fontSize: "14px",
    },

    statusBadge: {

      padding: "8px 14px",

      borderRadius: "999px",

      fontSize: "12px",

      fontWeight: "700",

      display: "inline-block",

      textTransform:
        "capitalize",

      letterSpacing: "0.4px",
    },

    pageBtn: {

      width: "42px",

      height: "42px",

      borderRadius: "14px",

      border:
        "1px solid #dbeafe",

      background: "#fff",

      cursor: "pointer",

      fontWeight: "700",
    },

    pageIndicator: {

      padding: "10px 18px",

      borderRadius: "14px",

      background: "#eff6ff",

      color: "#1d4ed8",

      fontWeight: "700",

      fontSize: "14px",

      minWidth: "90px",

      textAlign: "center",
    },

    center: {

      textAlign: "center",

      padding: "40px",

      color: "#64748b",

      fontWeight: "500",
    },

    error: {

      background: "#fee2e2",

      color: "#b91c1c",

      padding: "14px",

      borderRadius: "14px",

      marginTop: "12px",

      fontWeight: "600",
    },
  };
}

// =====================================================
// HIDE SCROLLBAR
// =====================================================

if (typeof document !== "undefined") {

  document.addEventListener(
    "DOMContentLoaded",
    () => {

      const style =
        document.createElement("style");

      style.innerHTML =
        `::-webkit-scrollbar {
          display: none;
        }`;

      document.head.appendChild(style);
    }
  );
}